<template>
  <span
    :class="[
      'toggle-fi',
      variant ? `toggle-fi--${variant}` : null,
      disabled ? 'toggle-fi--disabled' : null,
      label ? 'toggle-fi--with-label' : null,
    ]"
    @click="clickHandler"
  >
    <span
      :class="[
        'toggle-fi__toggle',
        isChecked ? 'toggle-fi__toggle--checked' : 'toggle-fi__toggle--unchecked',
      ]"
      :tabindex="tabindex"
      :autofocus="autofocus"
      :aria-checked="isChecked"
      role="checkbox"
      @blur="blurHandler"
      @focus="focusHandler"
      @keydown="onWrapperKeydown"
    >
      <input
        :id="id"
        ref="input"
        :value="currentValue"
        :name="name"
        :disabled="disabled"
        :readonly="readonly"
        :required="required"
        type="hidden"
      />
      <span
        class="toggle-fi__checked-placeholder"
        aria-hidden
      />
      <span
        class="toggle-fi__unchecked-placeholder"
        aria-hidden
      />
      <span
        ref="button"
        :class="isChecked ? 'toggle-fi__button--checked' : 'toggle-fi__button'"
        aria-hidden
      />
    </span>

    <label
      v-if="label"
      :for="id"
    >
      {{ label }}
    </label>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import binaryInputMixin from '@/mixins/binaryInputMixin.vue';

import checkboxMixin from '../checkbox-fi/checkboxMixin.vue';

export default defineComponent({
  name: 'ToggleFi',
  mixins: [binaryInputMixin, checkboxMixin],
  props: {
    id: {
      type: String,
      default: undefined,
    },
    name: {
      type: String,
      default: undefined,
    },
    uncheckedValue: {
      type: [String, Object, Number, Boolean, Array],
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: undefined,
    },
    required: {
      type: Boolean,
      default: undefined,
    },
    tabindex: {
      type: [String, Number],
      default: undefined,
    },
    variant: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    currentValue() {
      return this.isChecked ? this.value : this.uncheckedValue;
    },
  },
});
</script>

<style scoped src="./toggle-fi" />
